<template>
  <Modal title="身份验证" @open="handleOpen" @ok="handleOk" @close="handleClose" :btns="method === 'wechat' ? [] : null">
    <a-form :labelCol="{ span: 5 }">
      <a-form-item label="选择验证方式">
        <a-select v-model:value="method">
          <a-select-option v-for="opt in methodOptions" :key="opt.value" :value="opt.value">
            {{ opt.title }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-if="method === 'pwd'" label="账户密码">
        <a-input-password
          v-model:value="formData.pwd"
          placeholder="请输入账户密码"
        ></a-input-password>
      </a-form-item>
      <template v-else-if="method === 'phone'">
        <a-form-item label="手机号码">
          <div>{{ maskedPhone }}</div>
        </a-form-item>
        <a-form-item label="验证码">
          <VerificationCodeInput
            v-model="formData.verificationCode"
            size="small"
            :rest-seconds="restSeconds"
            @send="handleSendCode('phone')"
          />
        </a-form-item>
      </template>
      <template v-else-if="method === 'email'">
        <a-form-item label="邮箱地址">
          <div>{{ user.email }}</div>
        </a-form-item>
        <a-form-item label="验证码">
          <VerificationCodeInput
            v-model="formData.verificationCode"
            size="small"
            :rest-seconds="restSeconds"
            @send="handleSendCode('email')"
          />
        </a-form-item>
      </template>
      <a-form-item v-else-if="method === 'wechat'" label="微信扫码">
        <div id="code"></div>
      </a-form-item>
    </a-form>
  </Modal>
</template>

<script setup lang="ts">
import type { selfInfo } from '@elecmap/api/src/ram.d'
import { Modal } from '@elecmap/elecmap-ui'
import { computed, ref, watch } from 'vue'
import VerificationCodeInput from '@elecmap/shared/src/components/VerificationCodeInput.vue'
import {
  checkAccountEmail,
  checkAccountPassword,
  checkAccountPhone,
  checkWechatScanVerification,
  verificationCode,
  weChatVerificationConfig,
} from '@elecmap/api/src/ram'
import { useSendButton } from './send-button/use-send-button'
import { notificationError, notificationSuccess } from '@elecmap/shared/src/utils/notification'

const props = defineProps<{
  user: selfInfo
}>()

const formData = ref<any>({})
const { restSeconds, countDown, clearCountDown } = useSendButton()
const method = ref()
const methodOptions = computed<any[]>(() => {
  if (!props.user) return []
  const ret: Array<{ title: string; value: string }> = []
  if (props.user.userName) {
    ret.push({
      title: '账户密码',
      value: 'pwd',
    })
  }
  if (props.user.phone) {
    ret.push({
      title: '手机短信',
      value: 'phone',
    })
  }
  if (props.user.email) {
    ret.push({
      title: '邮箱验证码',
      value: 'email',
    })
  }
  if (props.user.bindWechat) {
    ret.push({
      title: '微信扫码',
      value: 'wechat',
    })
  }
  return Array.from(new Map(ret.map(item => [item.value, item])).values())
})
const maskedPhone = computed(() => {
  const phone = props.user?.phone
  if (!phone) return ''
  return phone.replace(/^(\d{3})\d{4}(\d+)$/, '$1****$2')
})

const emit = defineEmits(['success'])

function handleClose() {
  window.clearInterval(timeout)
  window.clearTimeout(polling4QR)
  clearCountDown()
  formData.value = {}
  method.value = undefined
}

async function handleOk() {
  if (method.value === 'wechat') return
  if (!method.value) {
    notificationError('当前无可用验证方式')
    return
  }
  if (method.value === 'pwd') {
    await checkAccountPassword({
      userName: props.user.userName,
      password: formData.value.pwd,
    })
  }
  if (method.value === 'phone') {
    await checkAccountPhone({
      phone: props.user.phone,
      verificationCode: formData.value.verificationCode,
    })
  }
  if (method.value === 'email') {
    await checkAccountEmail({
      email: props.user.email,
      verificationCode: formData.value.verificationCode,
    })
  }
  emit('success')
}

function handleSendCode(type: string) {
  const data: any = {}
  if (type === 'phone') {
    data.phone = props.user.phone
  }
  if (type === 'email') {
    data.email = props.user.email
  }
  countDown()
  verificationCode(data).then(() => {
    notificationSuccess('发送成功')
  })
}

function handleOpen() {
  method.value = methodOptions.value[0]?.value
}

let timeout: number | undefined
function checkScan() {
  checkWechatScanVerification().then(data => {
    if (data) {
      window.clearInterval(timeout)
      emit('success')
    }
  })
}

function queueCheck() {
  timeout = window.setInterval(() => {
    checkScan()
  }, 1000)
}

watch(
  () => method.value,
  m => {
    if (m === 'wechat') {
      drawQRCode()
    } else {
      window.clearTimeout(timeout)
    }
  },
)

let WeChatQCConfig: any
let polling4QR: number | undefined
const drawQRCode = () => {
  if (polling4QR) window.clearTimeout(polling4QR)
  // if (!formMode.value.isLogin && !formMode.value.isRegister) return

  const drawInner = () => {
    new window.WxLogin(WeChatQCConfig)

    polling4QR = window.setTimeout(drawQRCode, 3 * 60 * 1000)
  }

  weChatVerificationConfig().then(res => {
    WeChatQCConfig = {
      ...res,
      id: 'code',
      self_redirect: true,
    }
    drawInner()
    queueCheck()
  })
}
</script>

